import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';

const useStyles = makeStyles({
  value: {
    fontSize: '20px',
    fontWeight: '700',
  },
  title: {
    fontWeight: '400',
  },
  active: {
    fontWeight: '500',
  },
});

const TabLabel = ({ title, value, isActive }) => {
  const classes = useStyles();

  return (
    <div>
      <p
        className={classNames(classes.title, {
          [classes.active]: isActive,
        })}
      >
        {title}
      </p>
      <span className={classes.value}>{value}</span>
    </div>
  );
};

export default TabLabel;
